var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcNavProfile = function SvgIcNavProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8C19 11.3137 16.3137 14 13 14C9.68629 14 7 11.3137 7 8C7 4.68629 9.68629 2 13 2C16.3137 2 19 4.68629 19 8ZM21 8C21 12.4183 17.4183 16 13 16C8.58172 16 5 12.4183 5 8C5 3.58172 8.58172 0 13 0C17.4183 0 21 3.58172 21 8ZM2 24C2 23.658 2.16211 23.2417 2.6448 22.7662C3.13101 22.2872 3.88587 21.8098 4.89933 21.3875C6.92188 20.5448 9.78532 20 13 20C16.2147 20 19.0781 20.5448 21.1007 21.3875C22.1141 21.8098 22.869 22.2872 23.3552 22.7662C23.8379 23.2417 24 23.658 24 24H26C26 22.9613 25.4905 22.0623 24.7588 21.3414C24.0305 20.624 23.028 20.0239 21.8699 19.5414C19.5493 18.5745 16.4127 18 13 18C9.58726 18 6.4507 18.5745 4.1301 19.5414C2.97199 20.0239 1.96949 20.624 1.24124 21.3414C0.509459 22.0623 0 22.9613 0 24H2Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNavProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_nav_profile.7a8fbb41.svg";
export { ForwardRef as ReactComponent };